import { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { personalInfo } from '../data/portfolio';

export default function Contact() {
  const [ref, inView] = useInView(0.1);
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState(null);

  const handleChange = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('https://formspree.io/f/mdaylpll', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(form),
      });
      if (res.ok) { setStatus('success'); setForm({ name: '', email: '', subject: '', message: '' }); }
      else setStatus('error');
    } catch { setStatus('error'); }
  };

  const inputBase = {
    width: '100%',
    background: 'rgba(0,245,255,0.03)',
    border: '1px solid rgba(0,245,255,0.1)',
    borderRadius: '10px',
    padding: '0.85rem 1rem',
    color: 'var(--white)',
    fontFamily: 'var(--font-body)',
    fontSize: '0.88rem',
    outline: 'none',
    transition: 'border-color 0.25s, background 0.25s, box-shadow 0.25s',
    backdropFilter: 'blur(10px)',
  };

  const onFocus = e => { e.target.style.borderColor = 'rgba(0,245,255,0.4)'; e.target.style.background = 'rgba(0,245,255,0.05)'; e.target.style.boxShadow = '0 0 20px rgba(0,245,255,0.08)'; };
  const onBlur = e => { e.target.style.borderColor = 'rgba(0,245,255,0.1)'; e.target.style.background = 'rgba(0,245,255,0.03)'; e.target.style.boxShadow = 'none'; };

  const contacts = [
    { label: 'Email', value: personalInfo.email, href: `mailto:${personalInfo.email}`, icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg> },
    { label: 'LinkedIn', value: 'dharshithdev', href: personalInfo.linkedin, icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg> },
    { label: 'GitHub', value: 'github.com/dharshithdev', href: personalInfo.github, icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/></svg> },
    { label: 'Phone', value: personalInfo.phone, href: `tel:${personalInfo.phone}`, icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.78h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 10.1a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 21.5 17.56z"/></svg> },
  ];

  return (
    <section id="contact" className="section" style={{ background: 'linear-gradient(to bottom, var(--bg2), var(--bg))' }}>
      <div style={{ position: 'absolute', top: 0, left: '5%', right: '5%', height: 1, background: 'linear-gradient(to right, transparent, rgba(0,245,255,0.08), transparent)' }} />
      {/* Bottom glow */}
      <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '70vw', height: '30vh', background: 'radial-gradient(ellipse, rgba(0,245,255,0.05) 0%, transparent 70%)', filter: 'blur(30px)', pointerEvents: 'none' }} />

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          style={{ textAlign: 'center', marginBottom: '3.5rem' }}
        >
          <div className="sec-tag" style={{ justifyContent: 'center' }}>06 · Contact</div>
          <h2 className="sec-title">
            Let's build something{' '}
            <span style={{ background: 'linear-gradient(90deg, var(--cyan), var(--teal))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', display: 'block' }}>
              remarkable
            </span>
          </h2>
          <p style={{ color: 'var(--grey)', marginTop: '1rem', maxWidth: 440, margin: '1rem auto 0', fontSize: '0.92rem', lineHeight: 1.75 }}>
            Open to full-time roles, freelance, and AI/backend collaborations. Drop me a message.
          </p>
        </motion.div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.6fr', gap: 'clamp(1.5rem, 4vw, 3rem)', alignItems: 'start' }} className="grid-2">

          {/* Contact info */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
            style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}
          >
            {contacts.map(({ label, value, href, icon }, i) => (
              <motion.a
                key={label}
                href={href}
                target={label !== 'Email' && label !== 'Phone' ? '_blank' : undefined}
                rel="noopener noreferrer"
                initial={{ opacity: 0, x: -20 }}
                animate={inView ? { opacity: 1, x: 0 } : {}}
                transition={{ delay: 0.3 + i * 0.1, duration: 0.6 }}
                whileHover={{ x: 6 }}
                style={{
                  display: 'flex', alignItems: 'center', gap: '1rem',
                  padding: 'clamp(0.9rem, 2vw, 1rem) clamp(1rem, 2vw, 1.25rem)',
                  background: 'rgba(0,245,255,0.03)',
                  backdropFilter: 'blur(12px)',
                  border: '1px solid rgba(0,245,255,0.1)',
                  borderRadius: '12px',
                  transition: 'border-color 0.2s, background 0.2s, box-shadow 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(0,245,255,0.3)'; e.currentTarget.style.background = 'rgba(0,245,255,0.06)'; e.currentTarget.style.boxShadow = '0 0 20px rgba(0,245,255,0.08)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(0,245,255,0.1)'; e.currentTarget.style.background = 'rgba(0,245,255,0.03)'; e.currentTarget.style.boxShadow = 'none'; }}
              >
                <div style={{
                  width: 40, height: 40, borderRadius: '10px', flexShrink: 0,
                  background: 'rgba(0,245,255,0.08)',
                  border: '1px solid rgba(0,245,255,0.2)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'var(--cyan)',
                  boxShadow: '0 0 12px rgba(0,245,255,0.15)',
                }}>
                  {icon}
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: '0.55rem', letterSpacing: '0.12em', color: 'var(--grey2)', textTransform: 'uppercase' }}>{label}</div>
                  <div style={{ fontSize: '0.84rem', color: 'var(--white)', fontWeight: 500, marginTop: '0.1rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{value}</div>
                </div>
                <div style={{ marginLeft: 'auto', color: 'var(--grey2)', flexShrink: 0 }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m9 18 6-6-6-6"/></svg>
                </div>
              </motion.a>
            ))}
          </motion.div>

          {/* Form */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          >
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                {[
                  { name: 'name', label: 'NAME', placeholder: 'Your name', type: 'text' },
                  { name: 'email', label: 'EMAIL', placeholder: 'your@email.com', type: 'email' },
                ].map(f => (
                  <div key={f.name}>
                    <label style={{ fontFamily: 'var(--font-display)', fontSize: '0.55rem', letterSpacing: '0.15em', color: 'var(--grey2)', display: 'block', marginBottom: '0.45rem', textTransform: 'uppercase' }}>{f.label}</label>
                    <input type={f.type} name={f.name} required placeholder={f.placeholder} value={form[f.name]} onChange={handleChange} style={inputBase} onFocus={onFocus} onBlur={onBlur} />
                  </div>
                ))}
              </div>

              <div>
                <label style={{ fontFamily: 'var(--font-display)', fontSize: '0.55rem', letterSpacing: '0.15em', color: 'var(--grey2)', display: 'block', marginBottom: '0.45rem', textTransform: 'uppercase' }}>SUBJECT</label>
                <input type="text" name="subject" required placeholder="What's this about?" value={form.subject} onChange={handleChange} style={inputBase} onFocus={onFocus} onBlur={onBlur} />
              </div>

              <div>
                <label style={{ fontFamily: 'var(--font-display)', fontSize: '0.55rem', letterSpacing: '0.15em', color: 'var(--grey2)', display: 'block', marginBottom: '0.45rem', textTransform: 'uppercase' }}>MESSAGE</label>
                <textarea name="message" required placeholder="Tell me about your project or opportunity..." rows={5} value={form.message} onChange={handleChange} style={{ ...inputBase, resize: 'vertical', minHeight: 130 }} onFocus={onFocus} onBlur={onBlur} />
              </div>

              <motion.button
                type="submit"
                disabled={status === 'sending'}
                whileHover={{ scale: 1.02, y: -2 }}
                whileTap={{ scale: 0.98 }}
                className={status === 'success' ? '' : 'btn-cyan'}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.6rem',
                  padding: '0.95rem 2rem',
                  background: status === 'success' ? 'linear-gradient(135deg, #10b981, #059669)' : undefined,
                  color: '#000',
                  fontFamily: 'var(--font-display)',
                  fontWeight: 700,
                  fontSize: '0.72rem',
                  letterSpacing: '0.1em',
                  borderRadius: '10px',
                  opacity: status === 'sending' ? 0.7 : 1,
                  boxShadow: status === 'success' ? '0 0 30px rgba(16,185,129,0.3)' : undefined,
                  transition: 'background 0.3s',
                  border: 'none',
                }}
              >
                {status === 'sending' && (
                  <motion.div animate={{ rotate: 360 }} transition={{ duration: 0.8, repeat: Infinity, ease: 'linear' }}
                    style={{ width: 16, height: 16, border: '2px solid rgba(0,0,0,0.25)', borderTopColor: '#000', borderRadius: '50%' }} />
                )}
                {status === 'success' ? (
                  <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg> MESSAGE SENT!</>
                ) : status === 'sending' ? 'SENDING...' : (
                  <>SEND MESSAGE <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></>
                )}
              </motion.button>

              {status === 'error' && (
                <p style={{ fontFamily: 'var(--font-display)', fontSize: '0.65rem', color: '#f87171', textAlign: 'center', letterSpacing: '0.05em' }}>
                  Failed. Email me directly: {personalInfo.email}
                </p>
              )}
              <p style={{ fontFamily: 'var(--font-display)', fontSize: '0.52rem', color: 'var(--grey2)', textAlign: 'center', letterSpacing: '0.05em' }}>
              </p>
            </form>
          </motion.div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          #contact .container > div:last-child { gap: 2rem !important; }
        }
        @media (max-width: 480px) {
          #contact form > div:first-child { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
